module.exports = __webpack_public_path__ + "static/media/image6.9d44fb3e.jpg";